import React from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { PersonalQuestionList } from './PersonalQuestionList'

const StudentPersonalQuestions = () => {
	const { studentId } = useParams()
	const { user } = useAuth()

	// Detect if this is being viewed by instructor or student
	const isInstructorView = user?.role === 'Instructor'

	// Use studentId from params if instructor, otherwise use logged-in user's id
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	return (
		<StudentTopMenuLayout activeMenu="PersonalQuestions" pageName="PersonalQuestions">
			<PersonalQuestionList studentId={effectiveStudentId} />
		</StudentTopMenuLayout>
	)
}

export { StudentPersonalQuestions }
